import { useTranslations } from "use-intl";
import { useAppLocale } from "../i18n";

export const LanguageSwitcher = () => {
  const t = useTranslations("locale");
  const { locale, setLocale } = useAppLocale();

  return (
    <div
      aria-label={t("label")}
      className="locale-switch"
      role="group"
    >
      <button
        aria-label={t("ja")}
        aria-pressed={locale === "ja-JP"}
        className={locale === "ja-JP" ? "is-active" : undefined}
        data-flowtrace-id="locale.ja"
        onClick={() => setLocale("ja-JP")}
        title={t("ja")}
        type="button"
      >
        JA
      </button>
      <span aria-hidden="true">/</span>
      <button
        aria-label={t("en")}
        aria-pressed={locale === "en-US"}
        className={locale === "en-US" ? "is-active" : undefined}
        data-flowtrace-id="locale.en"
        onClick={() => setLocale("en-US")}
        title={t("en")}
        type="button"
      >
        EN
      </button>
    </div>
  );
};
